import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Link from '../Link'
import { FormattedMessage } from 'react-intl'
import * as styles from './index.module.css'
import globe from '../../../static/globe.svg'
import caret from '../../../static/caret.svg'

const Language = (props) => {
  const [open, setOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(
    typeof window !== `undefined` && window.innerWidth <= 767
  )
  const [isHovered, setIsHovered] = useState(false)

  const handleMouseHover = () => {
    setIsHovered(!isHovered)
  }

  const handleClick = () => {
    isMobile && setOpen(!open)
  }

  const links = props.langs.map((lang) => (
    <Link
      to={lang.link}
      key={lang.langKey}
      style={{
        color: 'white',
      }}
      onClick={() => {
        window.localStorage.setItem('ouster_dot_com_language', lang.langKey)
      }}
    >
      <li selected={lang.selected} className={styles.item}>
        {lang.langKey === 'en-us' && 'English'}
        {lang.langKey === 'zh-cn' && '中文'}
        {lang.langKey === 'jp' && '日本語'}
      </li>
    </Link>
  ))

  const format = props.id ? props.id : 'fullLang'

  return (
    <div
      className={styles.menu}
      style={{ color: 'white' }}
      onMouseEnter={handleMouseHover}
      onMouseLeave={handleMouseHover}
      onClick={handleClick}
    >
      <button className={styles.button}>
        <img src={globe} className={styles.globe} alt="globe" />
        <span className={styles.short}>
          <FormattedMessage id={format} />
        </span>
        <img
          src={caret}
          className={styles.caret}
          style={{
            transform: isHovered || open ? 'rotate(0)' : 'rotate(180deg)',
          }}
          alt="Dropdown Caret"
        />
      </button>

      {(isHovered || open) && <div className={styles.items}>{links}</div>}
    </div>
  )
}

Language.propTypes = {
  langs: PropTypes.array,
}

export default Language
